/**
Author - Babajan khan
Github - https://www.github.com/babajanpatan/
**/

import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import parseHtmlContent from "helpers/parseHtmlContent";

import {WealthyEnv} from "helpers";

import {AccordianItem} from "./components";
import parentContainer from "./components/ParentConatainer";

const propTypes = {
  faqList: PropTypes.array.isRequired
};

const Faqs = ({
  faqList
}) => {
  return (
    <>
      <Conatainer>
        <FaqContainer id="faqs">
          <SectionTitle>
          FAQs
          </SectionTitle>
          <FaqList>
            {
              faqList.map((faq, index) => (
                <AccordianItem
                  content={parseHtmlContent(faq.answer)}
                  key={index}
                  title={faq.question}
                />
              ))
            }
          </FaqList>
        </FaqContainer>
      </Conatainer>
    </>
  );
};

const Conatainer = styled(parentContainer)``;

const FaqContainer = styled.div`
  margin-bottom: 2rem;
  position: relative;

  @media (max-width: 1220px) {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  @media (max-width: 576px) {
    margin: 3.3rem auto;
    padding-bottom: 3.2rem;
  }
`;

const SectionTitle  = styled.div `
   display: flex;
  width: 18rem;
  flex-direction: column;
  flex-shrink: 0;
  color: #1C1C1C;
  font-family: MavenPro;
  font-size: 3rem;
  font-style: normal;
  font-weight: 600;
  line-height: 153.391%;

  @media (max-width: 768px) {
    margin-left:2rem;
  }
`;

const FaqList = styled.div`
  margin-top: 3rem;
  font-size: 2.2rem;

  @media (max-width: 576px) {
    margin-top: 1.6rem;
    font-size: 1.8rem;
  }
`;

Faqs.propTypes = propTypes;

export default Faqs;
